<template>
  <header class="header-menu-area" v-if="condition">
    <div class="header-menu-content dashboard-menu-content pr-30px pl-30px bg-white shadow-sm">
      <div class="container-fluid"></div>

    </div>
  </header>

  <section class="dashboard-area" v-if="condition">
    <div id="mainSiteMenu" style="scrollbar-width: none; " :class="calcExpandClass()"
      class="d-flex justify-content-around flex-column off-canvas-menu dashboard-off-canvas-menu off--canvas-menu custom-scrollbar-styled pt-20px">
      <div @click="expandMenu()" class="off-canvas-menu-close dashboard-menu-close icon-element icon-element-sm shadow-sm"
        data-toggle="tooltip" data-placement="right" title="بستن منو">
        <i class="la la-times"></i>
      </div>
      <NavBar></NavBar>
    </div>
  </section>
  <div v-if="condition" class="dashboard-content-wrap">
    <div @click="expandMenu()"
      class="dashboard-menu-toggler btn theme-btn theme-btn-sm lh-28 theme-btn-transparent mb-4 ml-3">
      <i class="la la-bars  fs-24"></i>
    </div>
    <router-view />
  </div>
  <router-view v-if="!condition" />
  <div v-if="checkScrolled" @click="scrollToTop()" id="scroll-top">
    <i class="la la-arrow-up" title="برو بالا"></i>
  </div>
  <div class="modal fade" id="modalLogout">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content py-4">
        <div class="modal-body text-center">
          <h3 class="modal-title">آیا می خواهید از برنامه خارج شوید؟</h3>
          <div class="btn-box pt-4">
            <button type="button" class="btn font-weight-medium mr-3" data-dismiss="modal">
              خیر
            </button>
            <button @click="logOut" type="button" class="btn theme-btn theme-btn-sm lh-30" data-dismiss="modal">
              بله
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import Header from "./components/Header.vue";
import axios from "axios";
import ls from "localstorage-slim";
import router from "./router/index";
import NavBar from "./components/NavBar.vue";
import 'primeicons/primeicons.css';

export default {
  components: {
    Header,
    NavBar,
  },
  data() {
    return {
      isExpanded: false,
      theme: ''

    }
  },
  computed: {
    condition() {
      if (
        this.$route.path === "/register" ||
        this.$route.path === "/login" ||
        this.$route.path === "/recover"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  beforeMount() {
    this.lgtCall();
    window.addEventListener('scroll', this.checkScrolled);
  },
  methods: {
    closeMenu() {
      document.body.style.overflow = "inherit";
      document.getElementById('mainSiteMenu').style.setProperty('z-index', 1, 'important');
      this.isExpanded = false;
    },
    expandMenu() {
      document.getElementById('mainSiteMenu').style.setProperty('z-index', 1035, 'important');
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        document.body.style.overflow = "hidden";
      } else {
        document.getElementById('mainSiteMenu').style.setProperty('z-index', 1, 'important');
        document.body.style.overflow = "inherit";
      }
    },
    calcExpandClass() {
      if (this.isExpanded) {
        return "active";
      } else {
        return "";
      }
    },
    checkScrolled() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop
      if (pageOffset > 300) {
        return true
      }
      else {
        return false
      }
    },
    scrollToTop() {
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    },
    logOut() {
      ls.clear();
      localStorage.clear();
      router.push("/login");
    },
    async lgtCall() {
      var usr = JSON.parse(ls.get("user"));
      if (usr === null) {
        return;
      }
      await axios
        .post("/api/v1/teacher/user/lgt", {
          mobile: usr.Mobile,
          password: usr.Password,
        })
        .then((response) => {
          if (response.status == 200 && response.data.data === "ok") {
            ls.set("token", response.data.token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + ls.get("token");
          } else {
            ls.clear();
            router.push("/login");
          }
        });
    },
  },
};
</script>

<style>
.p-component {
  font-family: IRANSans;
  text-align: center;
  font-weight: 400;
  font-size: 1.6rem;
}
</style>
